<template>
  <bvue-ui-view class="flex flex-col w-full" :scroll="true">
    <h1 class="flex-1">Especie</h1>
    <div class="form-group flex-1">
      <label>Nombre</label>
      <input type="text" class="form-input" v-model="item.name" />
    </div>
    <div class="form-group flex-1">
      <label>Nombre científico</label>
      <input type="text" class="form-input" v-model="item.scientificName" />
    </div>
    <div class="form-group flex-1">
      <label>Slug</label>
      <input type="text" class="form-input" v-model="item.slug" />
      El nombre que aparecerá en los csv al importar árboles
    </div>
    <div class="form-group flex-1">
      <label>Habitat</label>
      <input type="text" class="form-input" v-model="item.habit" />
    </div>
    <div class="form-group flex-1">
      <label>Habitat_us</label>
      <input type="text" class="form-input" v-model="item.habit_us" />
    </div>
    <div class="form-group flex-1">
      <label>Habitat_de</label>
      <input type="text" class="form-input" v-model="item.habit_de" />
    </div>
    <div class="form-group flex-1">
      <label>Estado</label>
      <input type="text" class="form-input" v-model="item.status" />
    </div>
    <div class="form-group flex-1">
      <label>Estado_us</label>
      <input type="text" class="form-input" v-model="item.status_us" />
    </div>
    <div class="form-group flex-1">
      <label>Estado_de</label>
      <input type="text" class="form-input" v-model="item.status_de" />
    </div>
    <div class="form-group flex-1">
      <label>Elevación</label>
      <input type="text" class="form-input" v-model="item.elevation" />
    </div>
    <div class="form-group flex-1">
      <label>Region</label>
      <input type="text" class="form-input" v-model="item.region" />
    </div>
    <div class="form-group flex-1">
      <label>Region_us</label>
      <input type="text" class="form-input" v-model="item.region_us" />
    </div>
    <div class="form-group flex-1">
      <label>Region_de</label>
      <input type="text" class="form-input" v-model="item.region_de" />
    </div>
    <div class="form-group flex-1">
      <label>Altura / año</label>
      <input type="text" class="form-input" v-model="item.height" />
    </div>
    <div class="form-group flex-1">
      <label>CO2 / año</label>
      <input type="text" class="form-input" v-model="item.co2" />
    </div>
    <div class="form-group flex-1">
      <label>Criterios de selección</label>
      <textarea name="selection" class="form-input" v-model="item.selection" />
    </div>
    <div class="form-group flex-1">
      <label>Criterios de selección_us</label>
      <textarea name="selection_us" class="form-input" v-model="item.selection_us" />
    </div>
    <div class="form-group flex-1">
      <label>Criterios de selección_de</label>
      <textarea name="selection_de" class="form-input" v-model="item.selection_de" />
    </div>
    <div class="form-group flex-1">
      <label>Uso</label>
      <textarea name="use" class="form-input" v-model="item.use" />
    </div>
    <div class="form-group flex-1">
    <label>Url del Video de Presentación</label>
      <input type="text" class="form-input" v-model="item.url" />
    </div>
    <div class="form-group flex-1">
      <label>Descripción</label>
      <textarea name="description" class="form-input" v-model="item.description" />
    </div>
    <div class="form-group flex-1">
      <label>Descripción_us</label>
      <textarea name="description_us" class="form-input" v-model="item.description_us" />
    </div>
    <div class="form-group flex-1">
      <label>Descripción_de</label>
      <textarea name="description_de" class="form-input" v-model="item.description_de" />
    </div>
    <div class=" flex my-4 justify-end">
      <div>
        <button @click="store" :class="['btn', 'btn-primary', loading]">{{isNew ? 'Crear' : 'Guardar'}}</button>
      </div>
    </div>
  </bvue-ui-view>
</template>

<script>
import firebase from '@/firebase'
export default {
  name: 'SpecieDetails',
  components: {  },
  props: {
    modalData: Object
  },
  data() {
    return {
      isNew: true,
      loading: [],
      item: {}
    }
  },
  methods: {
    async store() {
      this.loading = ['loading', 'disabled']
      const collection = firebase.firestore.collection('species')
      var item = this.item
      const id = this.item.id
      delete item.id
      await collection.doc(id).set(item)
      this.loading = []
      this.$bvueUi.modal.close()
    }
  },
  created() {
    console.log('this.modalData: ', this.modalData)
    if (this.modalData && this.modalData.id) {
      this.isNew = false
      this.item = this.modalData
    } else {
      this.item.id = firebase.firestore.collection('species').doc().id
    }
    console.log('this.item: ', this.item)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/SpecieDetails.vue